import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteOptionComponent } from './autocomplete-option/autocomplete-option.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [AutocompleteComponent, AutocompleteOptionComponent],
  imports: [CommonModule, InputModule, CheckboxModule, TooltipModule],
  exports: [AutocompleteComponent, AutocompleteOptionComponent],
})
export class AutocompleteModule {}
